// 基础路由相关
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
const { t } = useI18n()

// 根路由
export const RootRouter = {
  path: '/',
  component: Layout,
  redirect: '/product/direct-selling-product-list',
  name: 'Root',
  meta: {
    hidden: true
  }
}

// 重定向路由
export const RedirectRouter = {
  path: '/redirect',
  component: Layout,
  name: 'RedirectWrap',
  children: [
    {
      path: '/redirect/:path(.*)',
      name: 'Redirect',
      component: () => import('@/views/Redirect/Redirect.vue'),
      meta: {}
    }
  ],
  meta: {
    hidden: true,
    noTagsView: true
  }
}

// 登录路由
export const LoginRouter = {
  path: '/login',
  component: () => import('@/views/Login/Login.vue'),
  name: 'Login',
  meta: {
    hidden: true,
    title: t('router.login'),
    noTagsView: true
  }
}

// 个人中心
export const PersonalRouter = {
  path: '/personal',
  component: Layout,
  redirect: '/personal/personal-center',
  name: 'Personal',
  meta: {
    title: t('router.personal'),
    hidden: true,
    canTo: true
  },
  children: [
    {
      path: 'personal-center',
      component: () => import('@/views/Personal/PersonalCenter/PersonalCenter.vue'),
      name: 'PersonalCenter',
      meta: {
        title: t('router.personalCenter'),
        hidden: true,
        canTo: true
      }
    }
  ]
}

// 404
export const NoFindRouter = {
  path: '/404',
  component: () => import('@/views/Error/404.vue'),
  name: 'NoFind',
  meta: {
    hidden: true,
    title: '404',
    noTagsView: true
  }
}

// Error
export const ErrorRouter = {
  path: '/error',
  component: Layout,
  redirect: '/error/404',
  name: 'Error',
  meta: {
    title: t('router.errorPage'),
    icon: 'vi-ci:error',
    alwaysShow: true,
    hidden: true
  },
  children: [
    {
      path: '404-demo',
      component: () => import('@/views/Error/404.vue'),
      name: '404Demo',
      meta: {
        title: '404'
      }
    },
    {
      path: '403-demo',
      component: () => import('@/views/Error/403.vue'),
      name: '403Demo',
      meta: {
        title: '403'
      }
    },
    {
      path: '500-demo',
      component: () => import('@/views/Error/500.vue'),
      name: '500Demo',
      meta: {
        title: '500'
      }
    }
  ]
}
